import React from 'react';
import { withTranslation } from 'react-i18next';

import * as Auth from 'util/auth';
import { Languages } from 'enums/index';
import * as http from '_http';
import openNotification from 'components/openNotification';
import { LANGUAGE_PREFERENCE } from 'util/constants';

class UserWidget extends React.Component {
  state = {
    visible: false
  };

  toggleMenu = () => {
    const { visible } = this.state;
    this.setState({ visible: !visible });
  };

  logout = () => {
    const { selectCustomer } = this.props;
    selectCustomer({
      customerId: null,
      customerDetails: { customerInfo: { name: null } }
    });
    Auth.logout();
  };

  async changeLanguagePreference(language) {
    const { changeLanguage, t } = this.props;
    changeLanguage(language);
    try {
      await http.patchRequest(`/user/language/${LANGUAGE_PREFERENCE[language]}`);
    } catch (e) {
      openNotification({
        description: t('landing.errorNotification.description.languageError'),
        className: 'error',
        message: t('landing.errorNotification.message.languageError')
      });
    }
  }

  render() {
    const { visible } = this.state;
    const { t, username } = this.props;

    return (
      <React.Fragment>
        <div id="user-widget" className={visible ? 'user-widget show' : 'user-widget'}>
          <div className="user">
            <div className="name">{username}</div>
            <div className="welcome">{username ? `${t('landing.userWidget.signedIn')}` : ''}</div>
          </div>
          <div
            id="user-pic"
            className="user-pic hover-brighten"
            role="button"
            tabIndex="0"
            onKeyPress={this.toggleMenu}
            onClick={this.toggleMenu}
          >
            <div className="pic"></div>
            <span className="menuicon fi flaticon-caret-down " />
          </div>
          {visible && (
            <div
              id="account-menu"
              className="account-menu show"
              role="button"
              tabIndex="-1"
              onKeyPress={() => {}}
              onClick={this.toggleMenu}
            >
              <ul>
                <li className="hide" id="ddl-change-profile">
                  <span className="icon fi flaticon-user" />
                  {t('landing.profile')}
                </li>
                <li className="hide" id="ddl-change-settings">
                  <span className="icon fi flaticon-gear" />
                  {t('landing.settings')}
                </li>
                <li id="ddl-change-language">
                  <span className="icon fi flaticon-subject" />
                  <div>
                    <div>{t('landing.changeLanguage')}</div>
                    <div className="sub-text">{t('landing.setLanguage')}</div>
                  </div>
                  <div className="submenu">
                    <ul>
                      <li
                        tabIndex="-2"
                        onKeyPress={() => {}}
                        onClick={() => this.changeLanguagePreference(Languages.EN)}
                        id="ddl-change-language-en"
                      >
                        <span className="linkbutton">English</span>
                      </li>
                      <li
                        tabIndex="-3"
                        onKeyPress={() => {}}
                        onClick={() => this.changeLanguagePreference(Languages.FR)}
                        id="ddl-change-language-fr"
                      >
                        <span className="linkbutton">French</span>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="hide" id="ddl-help">
                  <span className="icon fi flaticon-question-1" />
                  {t('landing.help')}
                </li>
                <li onClick={this.logout} id="ddl-logout">
                  <span className="icon fi flaticon-logout" />
                  {t('landing.logOut')}
                </li>
              </ul>
            </div>
          )}
          {visible && (
            <div
              role="button"
              tabIndex="-4"
              onKeyPress={() => {}}
              className="backgroundClickContainer"
              onClick={this.toggleMenu}
            />
          )}
        </div>
        <div role="button" tabIndex="-4" onKeyPress={() => {}} className="sidemenu-toggle" onClick={this.toggleMenu}>
          <i className="fi flaticon-menu"></i>
        </div>
        {/* <div
          role="button"
          tabIndex="-5"
          onKeyPress={() => {}}
          className={visible ? 'sidemenu-closer show' : 'sidemenu-closer'}
          onClick={this.toggleMenu}
        >
          <i className="fi flaticon-close"></i>
        </div> FIX AND ENABLE THIS LATER  */}
      </React.Fragment>
    );
  }
}

export default withTranslation()(UserWidget);
